<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header">
        <h3 class="card-title">Admission Terms & Conditions</h3>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Degree</label>
              <select class="form-control" v-model="id" v-on:change="loadTerms()">
                <option value="0">--Select Degree--</option>
                <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row" v-if="id != 0">
          <div class="col-md-12" style="padding-bottom: 75px">
            <label>Terms (display on submiting/posting online-application)</label>
            <quill-editor v-model="terms" />
          </div>

          <div class="col-md-12" style="padding-bottom: 75px">
            <label>Admission Procedure: A Guideline for Applicants</label>
            <quill-editor v-model="guideline" />
          </div>

          <div class="col-md-12" style="padding-bottom: 75px">
            <label>Candidate's Undertaking</label>
            <quill-editor v-model="undertaking" />
          </div>
        </div>

      </div>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-primary">Back to List</button>
      <input type="submit" value="Save" class="btn btn-success float-right" />
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default;

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { quillEditor } from 'vue-quill-editor'

  export default ({
    components: {
      quillEditor
    },
    data() {
      return {
        degrees: [],
        id: 0,
        terms: '',
        guideline: '',
        undertaking: ''
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/pageLoadAdmissionTermsAndCondition")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.degrees = res.data.data;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadTerms() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/loadAdmissionTermsAndCondition?degreeID=" + vm.id)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.terms = res.data.data.Terms;
              vm.guideline = res.data.data.Guideline;
              vm.undertaking = res.data.data.Undertaking;

            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/saveAdmissionTermsAndCondition', {
          DegreeID: vm.id,
          Terms: vm.terms,
          Undertaking: vm.undertaking,
          Guideline: vm.guideline,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.clear();
            }
            else
              toastr.error(res.data.msg);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },

      clear() {
        this.id = 0,
          this.terms = '',
          this.guideline = '',
          this.undertaking = ''
      }
    }
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/admissionTermsCondition.vue